import moment from 'moment';
import { numberUnmask, removeSpace } from 'utils/masks';
import addressSchema from './addressSchema';

const addDebitCardSchema = {
  ...addressSchema,
  cardNumber: [{
    rule: 'required',
    error: 'The input field is required',
    isValid: (input) => {
      if (input && input.includes('X')) return true;

      if (!input || removeSpace(input).length === 0) {
        return 'The input field is required';
      }

      if (numberUnmask(input).length < 16) {
        return 'Card number is not valid';
      }

      if (
        !numberUnmask(input).startsWith('4')
        && !numberUnmask(input).startsWith('5')
        && !numberUnmask(input).startsWith('6')
      ) {
        return 'Currently we accept only Discover, Visa or Mastercard';
      }

      return true;
    },
  }],
  expirationDate: [{
    rule: 'required',
    error: 'The input field is required',
    isValid: (input) => {
      if (input && input.includes('X')) return true;

      if (!input || removeSpace(input).length === 0) {
        return 'The input field is required';
      }

      if (numberUnmask(input).length < 6 || !moment(input, 'MM/YYYY').isValid()) {
        return 'Expiration Date is not valid';
      }

      return moment(input, 'MM/YYYY').endOf('month').isSameOrBefore(moment().startOf('month')) ? 'Expiration Date is not valid' : true;
    },
  }],
};

export default addDebitCardSchema;
